import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";

const Manifesto = () => {
  const { t } = useLang();
  return (
    <section className="mx-auto max-w-7xl px-6 py-24 lg:px-10 lg:py-36">
      <motion.h2
        initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
        transition={{ duration: 0.7 }}
        className="mb-16 max-w-3xl font-heading text-4xl font-bold leading-tight tracking-tight text-primary lg:text-5xl">
        {t.manifesto.title}
      </motion.h2>

      <div className="grid grid-cols-1 gap-x-16 gap-y-4 md:grid-cols-2">
        {t.manifesto.items.map((item, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.08 }}
            className="relative overflow-hidden border-t border-border py-10"
            data-testid={`manifesto-${i}`}>
            <span className="pointer-events-none absolute -top-6 right-0 font-heading text-9xl font-extrabold text-primary/[0.04] select-none">
              0{i + 1}
            </span>
            <div className="relative border-l-2 border-accent pl-6">
              <h3 className="mb-3 font-heading text-2xl font-semibold text-secondary">{item.t}</h3>
              <p className="max-w-md text-base leading-relaxed text-muted-foreground">{item.d}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Manifesto;
